<template>
  <div>
    <b-checkbox
      v-model="buffer.isMonthly"
      :disabled="disabled"
      @input="$emit('input', buffer)"
    >
      <span v-if="buffer.isMonthly">
        <slot name="monthly">{{
          $t('compCarbonFormsConsumptionForm.field-1')
        }}</slot>
      </span>
      <span v-else>
        <slot name="total">{{
          $t('compCarbonFormsConsumptionForm.field-2')
        }}</slot>
      </span>
    </b-checkbox>
    <br />
    <br />
    <b-field
      :label="$t('compCarbonFormsConsumptionForm.field-3')"
      v-show="!buffer.isMonthly"
    >
      <b-input
        required
        :disabled="disabled"
        @input="$emit('input', buffer)"
        v-model="buffer.total"
      ></b-input>
    </b-field>
    <div class="columns is-variable is-1" v-show="buffer.isMonthly">
      <div class="column is-2">
        <b-field
          :label="$t('compCarbonFormsConsumptionForm.field-4')"
          :type="{ 'is-danger': errors.has('january') }"
          :message="errors.first('january')"
        >
          <b-input
            name="january"
            :disabled="disabled"
            v-validate="'required|numeric'"
            v-model="buffer.january"
            @input="$emit('input', buffer)"
          ></b-input>
        </b-field>
      </div>
      <div class="column is-2">
        <b-field
          :label="$t('compCarbonFormsConsumptionForm.field-5')"
          :type="{ 'is-danger': errors.has('february') }"
          :message="errors.first('february')"
        >
          <b-input
            name="february"
            :disabled="disabled"
            v-validate="'required|numeric'"
            v-model="buffer.february"
            @input="$emit('input', buffer)"
          ></b-input>
        </b-field>
      </div>
      <div class="column is-2">
        <b-field
          :label="$t('compCarbonFormsConsumptionForm.field-6')"
          :type="{ 'is-danger': errors.has('march') }"
          :message="errors.first('march')"
        >
          <b-input
            name="march"
            :disabled="disabled"
            v-validate="'required|numeric'"
            v-model="buffer.march"
            @input="$emit('input', buffer)"
          ></b-input>
        </b-field>
      </div>
      <div class="column is-2">
        <b-field
          :label="$t('compCarbonFormsConsumptionForm.field-7')"
          :type="{ 'is-danger': errors.has('april') }"
          :message="errors.first('april')"
        >
          <b-input
            name="april"
            :disabled="disabled"
            v-validate="'required|numeric'"
            v-model="buffer.april"
            @input="$emit('input', buffer)"
          ></b-input>
        </b-field>
      </div>
      <div class="column is-2">
        <b-field
          :label="$t('compCarbonFormsConsumptionForm.field-8')"
          :type="{ 'is-danger': errors.has('may') }"
          :message="errors.first('may')"
        >
          <b-input
            name="may"
            :disabled="disabled"
            v-validate="'required|numeric'"
            v-model="buffer.may"
            @input="$emit('input', buffer)"
          ></b-input>
        </b-field>
      </div>
      <div class="column is-2">
        <b-field
          :label="$t('compCarbonFormsConsumptionForm.field-9')"
          :type="{ 'is-danger': errors.has('june') }"
          :message="errors.first('june')"
        >
          <b-input
            name="june"
            :disabled="disabled"
            v-validate="'required|numeric'"
            v-model="buffer.june"
            @input="$emit('input', buffer)"
          ></b-input>
        </b-field>
      </div>
    </div>
    <div class="columns is-variable is-1" v-show="buffer.isMonthly">
      <div class="column is-2">
        <b-field
          :label="$t('compCarbonFormsConsumptionForm.field-10')"
          :type="{ 'is-danger': errors.has('july') }"
          :message="errors.first('july')"
        >
          <b-input
            name="july"
            :disabled="disabled"
            v-validate="'required|numeric'"
            v-model="buffer.july"
            @input="$emit('input', buffer)"
          ></b-input>
        </b-field>
      </div>
      <div class="column is-2">
        <b-field
          :label="$t('compCarbonFormsConsumptionForm.field-11')"
          :type="{ 'is-danger': errors.has('august') }"
          :message="errors.first('august')"
        >
          <b-input
            name="august"
            :disabled="disabled"
            v-validate="'required|numeric'"
            v-model="buffer.august"
            @input="$emit('input', buffer)"
          ></b-input>
        </b-field>
      </div>
      <div class="column is-2">
        <b-field
          :label="$t('compCarbonFormsConsumptionForm.field-12')"
          :type="{ 'is-danger': errors.has('septembre') }"
          :message="errors.first('septembre')"
        >
          <b-input
            name="septembre"
            :disabled="disabled"
            v-validate="'required|numeric'"
            v-model="buffer.septembre"
            @input="$emit('input', buffer)"
          ></b-input>
        </b-field>
      </div>
      <div class="column is-2">
        <b-field
          :label="$t('compCarbonFormsConsumptionForm.field-13')"
          :type="{ 'is-danger': errors.has('octobre') }"
          :message="errors.first('octobre')"
        >
          <b-input
            name="octobre"
            :disabled="disabled"
            v-validate="'required|numeric'"
            v-model="buffer.octobre"
            @input="$emit('input', buffer)"
          ></b-input>
        </b-field>
      </div>
      <div class="column is-2">
        <b-field
          :label="$t('compCarbonFormsConsumptionForm.field-14')"
          :type="{ 'is-danger': errors.has('novembre') }"
          :message="errors.first('novembre')"
        >
          <b-input
            name="novembre"
            :disabled="disabled"
            v-validate="'required|numeric'"
            v-model="buffer.novembre"
            @input="$emit('input', buffer)"
          ></b-input>
        </b-field>
      </div>
      <div class="column is-2">
        <b-field
          :label="$t('compCarbonFormsConsumptionForm.field-15')"
          :type="{ 'is-danger': errors.has('decembre') }"
          :message="errors.first('decembre')"
        >
          <b-input
            name="decembre"
            :disabled="disabled"
            v-validate="'required|numeric'"
            v-model="buffer.decembre"
            @input="$emit('input', buffer)"
          ></b-input>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['$validator'],
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: function () {
        return {
          january: 0,
          february: 0,
          march: 0,
          april: 0,
          may: 0,
          june: 0,
          july: 0,
          august: 0,
          septembre: 0,
          octobre: 0,
          novembre: 0,
          decembre: 0,
          total: 0,
          isMonthly: true
        }
      }
    }
  },
  data () {
    return {
      buffer: Object.assign({}, this.value)
    }
  },
  watch: {
    value: {
      handler () {
        this.buffer = Object.assign({}, this.value)
      },
      deep: true
    }
  }
}
</script>
